import type React from 'react';
import { ConfirmActionDrawer } from '@components/ui/confirm-action-drawer';
import { EndLivePollDrawer } from '@components/livePolls/EndLivePollDrawer';
import { usePollEnd } from '@hooks/usePollEnd';
import type { PollRead } from '@models/api/poll';
import { POLL_COPY } from './pollCopy';

export interface EndPollDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  question: { id: string; slug: string | null; is_my_question: boolean };
  poll: PollRead;
}

/**
 * E3, "End poll now"'s confirm: the default variant, Cancel first, then the bright-teal "End poll"
 * with an ink label; nothing is destroyed, so no red on a standard poll (RESOLUTIONS "Also
 * settled"). "End poll" closes the drawer and the card shows its final results at once (B3), the
 * server's block replacing the guess (`usePollEnd`).
 */
export const EndPollDrawer: React.FC<EndPollDrawerProps> = ({
  open,
  onOpenChange,
  question,
  poll,
}) => {
  const { end } = usePollEnd({
    questionId: question.id,
    slug: question.slug,
    isAuthor: question.is_my_question,
  });
  // A live poll (a platform admin's "End poll now", moderation): the one live End confirm, H6/L13 (FE-L1a
  // review). The live moves are the author's only (403 LIVE_NOT_AUTHOR), so it goes through the poll's End.
  if (poll.mode === 'live') {
    return (
      <EndLivePollDrawer
        open={open}
        onOpenChange={onOpenChange}
        noQuestionsRun={poll.current_position === null}
        onConfirm={() => {
          onOpenChange(false);
          end(poll);
        }}
      />
    );
  }
  return (
    <ConfirmActionDrawer
      open={open}
      onOpenChange={onOpenChange}
      title={POLL_COPY.endTitle}
      description={POLL_COPY.endBody}
      cancelLabel={POLL_COPY.cancel}
      confirmLabel={POLL_COPY.endConfirm}
      variant="default"
      onConfirm={() => {
        onOpenChange(false);
        end(poll);
      }}
    />
  );
};
